import { createIntegrationAPI } from "restAPI/GenericIntegrationAPI";

import {
  ZscalerS3Config,
  ZscalerS3ConfigRequest,
} from "../zscaler/zscalerConstants";

export const SENTINELONE_INTEGRATION_TYPE = "SENTINELONE_S3";

export type SentinelOneS3Config = ZscalerS3Config;
export type SentinelOneS3ConfigRequest = ZscalerS3ConfigRequest;

export const SentinelOneS3API = createIntegrationAPI<
  SentinelOneS3Config,
  SentinelOneS3ConfigRequest
>(SENTINELONE_INTEGRATION_TYPE);
